export default function ArrowIcon({ className }) {
  return (
    <svg
      viewBox="0 0 8 12"
      height={12}
      width={8}
      preserveAspectRatio="xMidYMid meet"
      className={className}
      version="1.1"
      x="0px"
      y="0px"
      enableBackground="new 0 0 8 12"
      xmlSpace="preserve"
    >
      <path
        className={className}
        d="M2.173,1l4.584,4.725L2.142,10.34L1.039,9.237l3.512-3.512L1,2.173L2.173,1z"
      />
    </svg>
  );
}
